import { useDispatch } from 'react-redux'
import { DELETE_TEXT, EDIT_TEXT } from '../../../utils/constants'
import { setDeleteRemarkId, setEditRemarkId } from '../../../store/visits/VisitsActions'

// @ts-expect-error TS7031 -- MIGRATION: not approved, fix when encountered
export const useEditRemarksPopupConfig = ({ setIsEditToolPopupOpened, remarkId }) => {
  const dispatch = useDispatch()

  const editRemarksPopupConfig = [
    {
      name: EDIT_TEXT,
      onClickCallBack: () => {
        setIsEditToolPopupOpened(false)
        dispatch(setEditRemarkId(remarkId))
      },
    },
    {
      name: DELETE_TEXT,
      onClickCallBack: () => {
        setIsEditToolPopupOpened(false)
        dispatch(setDeleteRemarkId(remarkId))
      },
    },
  ]

  return editRemarksPopupConfig
}
